import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface ConfigNomorSuratRow {
  id: number;
  nama_surat: string;
  start: number;
}

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

const BASE = "/superadmin/config-nomor-surat";

export default {
  async listNomorSurat(search = ""): Promise<ConfigNomorSuratRow[]> {
    const res = await handle(
      http.getDataParam(BASE, { params: search ? { search } : {} })
    );
    return res.data.data || [];
  },

  async createNomorSurat(
    payload: Partial<ConfigNomorSuratRow>
  ): Promise<ConfigNomorSuratRow> {
    const res = await handle(http.postData(BASE, payload));
    return res.data;
  },

  async updateNomorSurat(
    id: number,
    payload: Partial<ConfigNomorSuratRow>
  ): Promise<ConfigNomorSuratRow> {
    const res = await handle(http.putData(`${BASE}/${id}`, payload));
    return res.data;
  },

  async deleteNomorSurat(id: number): Promise<void> {
    await handle(http.deleteData(`${BASE}/${id}`));
  }
};
